import { FC, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { BUTTON_TYPES, BUTTON_VARIANTS } from '../../constants/button-variants';
import ROUTES from '../../constants/routes';
import translation, { world } from '../../languages';
import { AVAILABLE_WORLDS } from '../../languages/constants';
import { getDownloadHref } from '../../services/downloads/get-download-href';
import qualityEvents from '../../services/quality-events/quality-events';
import navigateFreeThankYou from '../../utils/material/navigate-free-thank-you';
import Button from '../../ui/button/button';
import Icon from '../icon/icon';
import './download-button.scss';

type DownloadButtonProps = TranslationProps & {
    aclId?: number | null;
    downloadStatus: string;
    id?: string;
    materialId: number;
    onDownload?: (e?: Event) => void;
    token?: string;
    type?: BUTTON_TYPES;
    name?: string;
    text?: string;
};

const DownloadButton: FC<DownloadButtonProps> = (props) => {
    const {
        downloadStatus,
        token,
        id,
        materialId,
        aclId,
        type = 'button',
        t,
        onDownload,
        name = 'download',
        text
    } = props;

    const isDownloadingRef = useRef<boolean>(false);
    const navigate = useNavigate();
    const isBoughtPage = window.location.pathname.includes(ROUTES.BOUGHT_MATERIALS.path);

    const downloadMaterial = async () => {
        if (isDownloadingRef.current || !materialId) {
            return;
        }
        isDownloadingRef.current = true;

        try {
            if (onDownload) {
                onDownload();

                return;
            }
            const isFree = downloadStatus === 'free';

            if (isFree && !isBoughtPage && world === AVAILABLE_WORLDS.DE) {
                navigateFreeThankYou({ navigate, materialId });
            } else {
                await getDownloadHref({
                    id: (isFree ? token : aclId) || '',
                    isDirectLink: isFree,
                    isFree
                });
            }

            await qualityEvents.general.downloadPurchasedMaterial(materialId);
        } catch (err) {
            console.error(err);
        } finally {
            isDownloadingRef.current = false;
        }
    };

    if (type === 'icon') {
        return <Icon name={name} onClick={downloadMaterial} />;
    }

    return (
        <Button
            id={id}
            className='download-button'
            disabled={isDownloadingRef.current}
            variant={BUTTON_VARIANTS.SECONDARY}
            onClick={downloadMaterial}
        >
            <Icon animated={false} height={16} name='download' text={text || t('common.materialBlock.download2')} />
        </Button>
    );
};

const translate = translation('common');

export default translate(DownloadButton);
